export enum WizardCompanyEnum {
  Contract = 'contract',
  Data = 'data',
  Partner = 'partner',
  Representative = 'representatives',
  Bank = 'bank',
  EconomicGroup = 'economic-group',
  Authorizations = 'authorizations',
  Suitability = 'suitability/questions',
  Relationship = 'relationship',
  Confirmation = 'confirmations',
  FiscalData = 'fiscal-data',
  AssetPortfolio = 'assets-portfolio',
  FinancialInformation = 'financial-information',
  Patrimonial = 'patrimonial',
  Beneficiaries = 'beneficiaries',
  PaymentAccountOpening = 'payment-account-opening'
}
